const React = require('react');
import UpdateIcon from '@material-ui/icons/Update';

module.exports = ({
  name,
  href,
  onClick,
  disabled,
  ...props
}) => {
  return (
    <a
      {...props}
      href={disabled ? undefined : href}
      onClick={disabled ? undefined : onClick}
      className={`layoutRow fvaC fhaS f12 fw4 lts0em tdN olN ttU c5B47FF dn o70:h crUnset:h.disabled o50:h.disabled o50.disabled `
        + (disabled ? 'disabled ' : '')
        + (props.className || '')}
    >
      <div className="pr6">{name || 'Update'}</div>
      <UpdateIcon
        className="w18-i"
      />
    </a>
  );
};